<template>
  <div style="display: flex; flex-direction: column; align-items: flex-start">
    <div
      style="
        display: flex;
        flex-direction: row-reverse;
        align-items: flex-start;
      "
    >
      <UploadDocAndCreateSzvmModal
        ref="uploadDocumentModal"
        :loading="loading"
        class="taxation-type__select"
        :szvm-documents="szvmDocuments"
        :name-document="dataEdit.documentType"
        :data-edit="dataEdit"
        :source-id="dataEdit.sourceId"
        :object-data="objectData"
        @getedZip="getedZip"
        @uploadImages="uploadFile"
        @deleteFileDocument="deleteFile"
        @createdDocument="createDocumentSzvm"
        @deletedDocument="deleteDocument"
      />
      <span style="margin-right: 12px">
        <el-select
          v-model="hiredStatus"
          class="taxation-type__select"
          style="width: 225px"
          placeholder="Наемные водители:"
        >
          <el-option
            v-for="item in hiredOptions"
            :key="item.value"
            :disabled="item.value === 'undefined'"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="warning" @click="onUpdate"> Сохранить тип </el-button>
      </span>
    </div>
  </div>
</template>

<script>
import {
  DELETE_FILE_DOCUMENT,
  UPLOAD_FILE_IMG_DOCUMENT,
} from '@/store/actions/contracts'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDatePickerFormat } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'
import { hiredOptions } from './constants'
import { showErrorMessage } from '@/helpers/functions'
import UploadDocAndCreateSzvmModal from '@/components/Upload/UploadDocAndCreateSzvmModal'
import mapGetters, { mapActions } from 'vuex'
const DocumentRepository = RepositoryFactory.get('document')

export default {
  name: 'HiredType',
  components: {
    UploadDocAndCreateSzvmModal,
  },
  props: {
    status: {
      type: Number,
      default: 0,
    },
    contragent: {
      type: Object,
      default: () => Object(),
    },
  },
  data() {
    return {
      loading: false,
      objectData: {},
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'заявка на СЗВМ',
        childFilesCountProperty: 'countFiles',
      },
      szvmDocuments: [],
      hiredOptions,
      dataEdit: {
        sourceModelName: 'contragents',
        sourceId: 0,
        documentType: 'szvm_insurance',
        documentTypeIdByType: null,
      },
    }
  },
  computed: {
    // ...mapGetters(['getContragentLoading']),
    hiredStatus: {
      get() {
        return this.status || 0
      },
      set(val) {
        this.$emit('set', val)
      },
    },
  },
  watch: {
    contragent: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.objectData = newVal
        this.dataEdit.sourceId = newVal.id
        this.dataEdit.documentTypeIdByType = this.getDocumentTypeIdByType(
          this.dataEdit.documentType,
        )
        this.szvmDocuments = newVal.documents?.filter(
          item => item.document_type_id === this.dataEdit.documentTypeIdByType,
        )
      },
    },
  },
  methods: {
    ...mapActions({
      deleteFileDocument: DELETE_FILE_DOCUMENT,
      uploadFileDocument: UPLOAD_FILE_IMG_DOCUMENT,
    }),
    deleteDocument(data) {
      this.loading = true
      DocumentRepository.deleteDocument(data)
        .then(() => {
          this.$store.dispatch('fetchContragentByInn', this.contragent.inn)
          this.$message.success('Документ СЗВМ успешно удален')
        })
        .catch(() => {
          this.$message.error('Ошибка! Документ не удален.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    createDocumentSzvm(data) {
      this.loading = true
      DocumentRepository.createDocument(
        this.dataEdit.sourceModelName,
        this.dataEdit.sourceId,
        this.getDocumentTypeIdByType(this.dataEdit.documentType),
        {
          document_create_date: getDateOfCertainFormat(
            data.document_create_date,
            defaultDatePickerFormat,
          ),
        },
      )
        .then(response => {
          console.log(3333, response.data)

          this.$store.dispatch('fetchContragentByInn', this.contragent.inn)
          this.$message.success('Документ СЗВМ успешно добавлен')
        })
        .catch(e => {
          showErrorMessage(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.$emit('save')
    },
    uploadFile(param1, param2) {
      this.$store.dispatch('fetchContragentByInn', this.contragent.inn)
      this.uploadFileDocument(param1, param2).then(() =>
        this.$store.dispatch('fetchContragentByInn', this.contragent.inn),
      )
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', 'file.zip') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    getedZip(document_id) {
      this.downloadRegistry({
        path: DocumentRepository.getZipUrl(document_id),
        blank: 1,
      })
    },
    deleteFile(data) {
      if (data.constructor === Array) {
        data.map(id =>
          this.deleteFileDocument(id).then(() =>
            this.$store.dispatch('fetchContragentByInn', this.contragent.inn),
          ),
        )
      } else {
        this.deleteFileDocument({ ...data, inn: this.contragent.inn })
      }
    },
  },
}
</script>

<style lang="sass">
.taxation-type
  &__select.el-select
    width: auto
    margin-right: 10px
</style>
